export const ACCOUNT_MANUAL_NAME = "Invoice Payouts Account";
